module["exports"] = [
  "сохранить",
  "обойти",
  "взломать",
  "переопределить",
  "сжать",
  "зашифровать",
  "импортировать",
  "экспортировать",
  "копировать",
  "навигировать",
  "индексировать",
  "соединить",
  "генерировать",
  "распарсить",
  "квантифицировать",
  "вычислить",
  "синтезировать",
  "ввести",
  "передать",
  "запрограммировать",
  "перезагрузить",
  "разобрать"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/hacker/verb.js
// module id = 3529
// module chunks = 1610